import React, { createContext, useState, useContext, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');

  useEffect(() => {
    // Detect browser language on mount
    const browserLang = navigator.language || navigator.userLanguage;
    const detectedLang = browserLang.toLowerCase().startsWith('fr') ? 'fr' : 'en';
    
    // Check if language is saved in localStorage
    const savedLang = localStorage.getItem('preferredLanguage');
    
    if (savedLang) {
      setLanguage(savedLang);
    } else {
      setLanguage(detectedLang);
      localStorage.setItem('preferredLanguage', detectedLang);
    }
  }, []);

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('preferredLanguage', lang);
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
